module.exports = __webpack_public_path__ + "static/media/Aalidhra10a2.55d25741.jpg";